<template>
    <div id="checkout-payment-orange-money" class="tab-pane fade"
         :class="{ show: chosenMethod, active: chosenMethod }" role="tabpanel">
        <div class="row align-items-center">
            <div class="col-12 col-md-8">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input c-pointer" v-model="accepted"
                           type="checkbox" id="accept-orange-money">
                    <label v-html="$t('checkout.payment.acceptOrangeMoney', generalInfos)"
                           class="custom-control-label c-pointer" for="accept-orange-money"></label>
                </div>
            </div>
            <div class="col-12 col-md-4 text-center">
                <button @click="setBillingMethod" class="btn btn-primary" :disabled="!accepted">
                    {{$t("checkout.payment.payWithOrangeMoney")}}
                </button>
            </div>
        </div>
        <transition name="fade">
            <div v-if="accepted" class="row">
                <div class="col-12 text-center">
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input v-model="saveAsFavoritePaymentMethod" class="custom-control-input c-pointer" type="checkbox" id="favorite-payment-method-orange-money">
                        <label class="custom-control-label c-pointer" for="favorite-payment-method-orange-money">
                            {{ $t("CheckoutPayment.favoritePaymentMethod") }}
                        </label>
                    </div>
                    <RequiredForOneClickOrder/>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import orangeMoney from "../../../../assets/img/payments/orangeMoney.png";
import RequiredForOneClickOrder from "../../../shared/Order/RequiredForOneClickOrder";

export default {
    name: "CheckoutPaymentOrangeMoney",
    components: {RequiredForOneClickOrder},
    props: {
        generalInfos: {
            type: Object,
            required: true,
        },
        preferences: {
            type: Object,
            required: true,
        },
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            accepted: false,
            orangeMoney,
            saveAsFavoritePaymentMethod: this.preferences.billing.method === "orangeMoney",
        };
    },
    computed: {
        chosenMethod() {
            return this.order.billing.method === "orangeMoney";
        },
    },
    methods: {
        setBillingMethod() {
            this.$emit("set-billing-method", {
                method: "orangeMoney",
                favoritePaymentMethod: this.saveAsFavoritePaymentMethod,
            });
        },
    },
};
</script>

<style scoped>

</style>